// Extrai a mensagem de erro de uma resposta da API:
// `error` (regra de negócio) ou o primeiro item de `errors` (validação do express-validator)
export const mensagemDeErro = (error: unknown, padrao: string): string => {
  const dados = (error as { response?: { data?: { error?: string; errors?: Array<{ msg?: string }> } } })
    ?.response?.data;
  return dados?.error || dados?.errors?.find(item => item?.msg)?.msg || padrao;
};
